import React from "react";
import "./FormHome.scss";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { useState } from "react";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";
import Api from "../../../Api";
const FormHome = () => {
  function sendEmail(e) {
    e.preventDefault();

    const data = {
      nome: nome,
      telefone: telefone,
      email: email,
      empresa: empresa,
      mensagem: mensagem,
    };

    Api.post("criar", data).then(
      (res) => {
        emailjs
          .sendForm(
            "service_jqezxqg",
            "template_irym1vf",
            e.target,
            "user_s58UnWwl1TmFQ2U2b7F6H"
          )
          .then(
            (result) => {
              e.target.reset();
              setNome("");
              setEmpresa("");
              setTelefone("");
              setEmail("");
              setMensagem("");
            },
            (error) => {
              console.log(error);
            }
          );
        Swal.fire({
          title: "Sucesso!",
          text: "Mensagem enviada com sucesso!",
          icon: "success",
          confirmButtonText: "Ok",
        });
      },
      (err) => {
        Swal.fire({
          title: "Erro!",
          text: "Falha ao enviar mensagem! Entre em contato com o suporte.",
          icon: "error",
          confirmButtonText: "Ok",
        });
        console.log(err);
      }
    );
  }

  const [nome, setNome] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [mensagem, setMensagem] = useState("");

  return (
    <>
      <div className="view-form-home" id="form-home">
        <Container>
          <Grid container spacing={12} columns={12}>
            <Grid item md={6} xs={12}>
              <div className="esquerda">
                <div className="infos">
                  <strong>
                    Entre em <br /> contato conosco
                  </strong>{" "}
                  <br /> <br />
                  <span>
                    Seg - Sex - 8h - 19h
                    <br />
                    comercial@bupin.com.br <br />
                    (54) 9 9841-2011
                  </span>
                </div>
              </div>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              style={{
                paddingTop: window.screen.availWidth <= 768 ? "0" : "90px",
              }}
            >
              <form onSubmit={sendEmail}>
                <input
                  type="text"
                  placeholder="Nome"
                  name="nome"
                  value={nome}
                  onChange={(e) => {
                    setNome(e.target.value);
                  }}
                  required
                />{" "}
                <br />
                <input
                  type="text"
                  placeholder="Telefone"
                  name="telefone"
                  value={telefone}
                  onChange={(e) => {
                    setTelefone(e.target.value);
                  }}
                  required
                />{" "}
                <br />
                <input
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  required
                />{" "}
                <br />
                <input
                  type="text"
                  placeholder="Empresa"
                  name="empresa"
                  value={empresa}
                  onChange={(e) => {
                    setEmpresa(e.target.value);
                  }}
                  required
                />{" "}
                <br />
                <textarea
                  name="mensagem"
                  id=""
                  cols="30"
                  rows="10"
                  placeholder="Mensagem"
                  value={mensagem}
                  onChange={(e) => {
                    setMensagem(e.target.value);
                  }}
                ></textarea>
                <div className="botao">
                  <button
                    className={
                      !nome || !email || !mensagem ? "desabilitado" : ""
                    }
                  >
                    Enviar
                  </button>
                </div>
              </form>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
};

export default FormHome;
